module.exports = __webpack_public_path__ + "static/img/rank_50.25909a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_50.png
// module id = 3ELP
// module chunks = 1